import { MODULE_OWNERSHIP } from './constant';
import type { SentryModule } from './types';

export { MODULE_OWNERSHIP } from './constant';

export const owningTeamForModule = (
  module?: SentryModule,
): string | undefined => (module ? MODULE_OWNERSHIP[module] : undefined);
